/* eslint-disable jsx-a11y/media-has-caption */
import { MutableRefObject } from 'react'

import { useLayoutEffect, useRef } from 'react'
import videojs from 'video.js'

import 'video.js/dist/video-js.css'

type VideoRef = MutableRefObject<HTMLVideoElement>

type PlayerOptions = {
  autoplay?: boolean,
  controls?: boolean,
  sources?: object[],
};

const initVideoPlayer = (videoRef: VideoRef, playerOptions?: PlayerOptions) => {
  const player = videojs(videoRef.current, playerOptions)

  return () => {
    if (player) player.dispose()
  }
}

type VideoPlayerProps = {
  playerOptions?: PlayerOptions,
  style?: object,
}

const VideoPlayer = (props: VideoPlayerProps) => {
  const { playerOptions, style } = props

  // @ts-expect-error TS2322
  const videoRef: VideoRef = useRef()
  useLayoutEffect(() => initVideoPlayer(videoRef, playerOptions), [JSON.stringify(playerOptions)])

  return (
    <div data-vjs-player key={JSON.stringify(playerOptions)}>
      <video
        className="video-js vjs-big-play-centered"
        ref={videoRef}
        style={{
          backgroundColor: '#f8f8f8', width: '100%', height: '100%', ...style,
        }}
      />
    </div>
  )
}

export default VideoPlayer
